import React from "react";
import { useState, useEffect, useRef } from "react";
import PrescriptionTable from "./PrescriptionTable";
import { useNavigate } from "react-router-dom";
import { Panel, PanelGroup, Placeholder } from "rsuite";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Whisper, Tooltip } from "rsuite";
import { RiGridFill, RiListUnordered } from "react-icons/ri";
import { FiFilter, FiUser, FiSearch, FiX } from "react-icons/fi";
import ClinicFilterPopover from "./ClinicFilterPopover";
import {
  useGetPrescriptionListViewQuery,
  usePostFilteredPrescriptionMutation,
} from "../State/Api/AddPrescriptionApiSlice";
import Clinicsideprescriptionfilters from "./Clinicsideprescriptionfilters";
import DefaultPatientFilters from "./ClinicComponent/Filters/DefaultPatientFilters";
import PrescriptionViewFilters from "./ClinicComponent/Filters/ClinicFilterJSON/PrescriptionView";


function Prescription() {
  const userClinicID = localStorage.getItem("userClinicID");
  const doctorUserUniqueID = localStorage.getItem("userUniqueID");


  const [show, setShow] = useState(false);
  const [prescriptionDetail, setPrescriptionDetail] = useState("");
  const [selectedFilters, setSelectedFilters] = useState({});
       const [hasData, setHasData] = useState(true);

  const gridRef = useRef(null);

  const prevFiltersRef = useRef([]);

  useEffect(() => {
    // Only purge if filters actually changed
    if (
      JSON.stringify(prevFiltersRef.current) !== JSON.stringify(selectedFilters)
    ) {
      gridRef?.current?.api?.purgeInfiniteCache();
      prevFiltersRef.current = selectedFilters;
    }
  }, [selectedFilters]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [activeView, setActiveView] = useState("list");

  const navigate = useNavigate();

  const [
    postFilteredPrescription,
    { data = [], isLoading, isSuccess, isFetching },
  ] = usePostFilteredPrescriptionMutation();

  const getPrescription = async (pageNumber, filters, sortColumn = "", sortOrder = "") => {
    try {
      const result = await postFilteredPrescription({
        pageNumber: pageNumber,
        userUniqueID: doctorUserUniqueID,
        pageSize: 100,
        userClinicID: userClinicID,
        filters: filters,
        sortColumn: sortColumn,
        sortOrder: sortOrder
      }).unwrap();
      return result;
    } catch (err) {
     
    }
  };

  useEffect(() => {
    gridRef?.current?.api?.purgeInfiniteCache();
  }, [selectedFilters]);

  const handleSearch = () => {
    let searchValue = prescriptionDetail.trim();

    if (!searchValue) {
      // Clear filters if search empty
      setSelectedFilters((prev) => {
        const { fullName, patientIDUniqueID, ...rest } = prev;
        return rest;
      });
      return;
    }

    let newFilter;

    if (/^PLCRXPAT\d+$/i.test(searchValue)) {
      // Already formatted Patient ID
      newFilter = {
        patientIDUniqueID: {
          values: new Set([searchValue]),
          operator: "Contains",
        },
      };
    } else if (/^\d+$/.test(searchValue)) {
      // Only numbers → prepend prefix
      const prefixedValue = `PLCRXPAT${searchValue}`;
      newFilter = {
        patientIDUniqueID: {
          values: new Set([prefixedValue]),
          operator: "Contains",
        },
      };
    } else {
      // Otherwise treat as name
      newFilter = {
        fullName: {
          values: new Set([searchValue]),
          operator: "Contains",
        },
      };
    }

    setSelectedFilters((prev) => {
      const { fullName, patientIDUniqueID, ...rest } = prev;
      return { ...rest, ...newFilter };
    });
  };

  const handleClearSearch = () => {
    setPrescriptionDetail("");
    setSelectedFilters((prev) => {
      const { fullName, patientIDUniqueID, ...rest } = prev;
      return rest;
    });
     setHasData(true);
  };

  const getButtonClasses = (view) => {
    const isActive = activeView === view;
    return [
      "flex-1 flex items-center justify-center h-[36px] w-[50px] transition-all",
      isActive
        ? "bg-[#203342] text-white"
        : "bg-white text-[#203342] hover:bg-gray-100",
    ].join(" ");
  };

  const tooltipStyles = {
    backgroundColor: "#1f2937",
    color: "white",
    fontSize: "12px",
    padding: "6px 8px",
    borderRadius: "4px",
    boxShadow:
      "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    border: "none",
    maxWidth: "200px",
  };

  const styleaccordion = `

  .rs-panel-group-bordered {
    border: none;
  }

  .rs-panel-group {
    border-radius: none;
    overflow: hidden;
  }

  .rs-panel-btn:active, .rs-panel-btn:focus, .rs-panel-btn:hover{
    background-color: none !important;
  }

  .rs-panel:last-child {
    border-bottom: none !important;
  }

  .rs-panel-btn:active, .rs-panel-btn:focus, .rs-panel-btn:hover {
    background-color: #fff !important;
    color: #343434;
    color: var(--rs-btn-subtle-hover-text);
    outline: 2px solid transparent;
}

.rs-panel-title {
    -ms-flex: 1 1 0%;
    flex: 1 1;
    margin: 0;
    text-align: left;
    font-weight: 500 !important;
    color: #000;
}

.rs-panel-collapsible>.rs-panel-header {
    cursor: pointer;
    padding: 3px;
    position: relative;
    -webkit-transition: background-color .3s linear, border-radius .3s linear;
    transition: background-color .3s linear, border-radius .3s linear;
}

.offcanvas-body {
    flex-grow: 1;
    padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
    overflow-y: auto;
    padding: 0px;
}

  
  `;

  return (
    <>
      <style>{styleaccordion}</style>
      <main style={{ width: "100%", height: "100%" }}>
        <div className="row">
          <div
            style={{ borderBottom: "1px dashed gray", paddingBottom: "1rem" }}
            className="col-12 mb-4 d-flex flex-wrap justify-content-between align-items-center"
          >
            <div className="d-flex justify-content-between">
              <div>
                <h2 className="h3 fw-bold mb-0" style={{fontSize:'24px'}}>All Prescriptions</h2>
                {/* <p className="text-secondary">
                  Every prescription begins with care, not just a cure.{" "}
                </p> */}
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-end gap-3">
              <div className="d-flex align-items-center gap-3">
                <label className="relative">
                  <input
                    type="text"
                    maxLength={14}
                    className="pr-20 pl-4 py-2 border border-[#7eb592] rounded-lg w-full text-sm focus:outline-none ring-2 ring-[#7eb592]/20 focus:outline focus:border-[#7eb592] focus:ring-2 focus:ring-[#7eb592]/20"
                    placeholder="Enter patient name or ID"
                    value={prescriptionDetail}
                    onChange={(e) => {
                      const value = e.target.value;
                      setPrescriptionDetail(value);

                      if (value.trim() === "") {
                        setSelectedFilters((prev) => {
                          const { fullName, patientIDUniqueID, ...rest } = prev;
                          return rest;
                        });
                      }
                    }}
                    onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                  />

                  {prescriptionDetail && (
                    <Whisper
                      placement="top"
                      trigger="hover"
                      speaker={
                        <Tooltip className="!bg-gray-800 !text-white !text-xs !px-2 !py-1 !rounded !shadow-lg">
                          Clear search
                        </Tooltip>
                      }
                    >
                      <span
                        className="absolute right-12 top-9 transform -translate-y-1/2 p-2 rounded-md text-gray-500 hover:text-red-400 cursor-pointer transition-colors duration-200"
                        onClick={handleClearSearch}
                      >
                        <FiX size={16} />
                      </span>
                    </Whisper>
                  )}

                  <Whisper
                    placement="bottom"
                    trigger="hover"
                    delay={100}
                    speaker={
                      <Tooltip style={tooltipStyles}>
                        Search patients by name or Only last 4 digits of ID or
                        Department
                      </Tooltip>
                    }
                  >
                    <span
                      className="absolute right-[0.3rem] top-9 transform -translate-y-1/2 bg-[#7eb592] hover:bg-[#6ba080] p-2 rounded-md text-white cursor-pointer transition-colors duration-200"
                      onClick={handleSearch}
                    >
                      <FiSearch size={16} />
                    </span>
                  </Whisper>
                </label>
                 <Whisper
                placement="top"
                trigger="hover"
                speaker={<Tooltip>Filter Options</Tooltip>}
              >
                <button>
                  <DefaultPatientFilters
                    defaultFilters={PrescriptionViewFilters.default}
                    additionalFilters={PrescriptionViewFilters.additional}
                    selectedFilters={selectedFilters}
                    setSelectedFilters={setSelectedFilters}
                    setHasData={setHasData}
                  />
                </button>
              </Whisper>
                {/* <button
                  className="gradient-button"
                  style={{ color: "#fff" }}
                  onClick={() => navigate("/prescriptionform")}
                >
                  + Add Prescription
                </button> */}

                <div className="flex rounded-md overflow-hidden shadow-sm border border-gray-200 ml-[5px] w-fit">
                  <Whisper
                    placement="top"
                    trigger="hover"
                    speaker={<Tooltip>List view</Tooltip>}
                  >
                    <button
                      onClick={() => setActiveView("list")}
                      className={getButtonClasses("list")}
                    >
                      <RiListUnordered size={20} />
                    </button>
                  </Whisper>
                  {/* <Whisper
                    placement="top"
                    trigger="hover"
                    speaker={<Tooltip>Grid view</Tooltip>}
                  >
                    <button
                      onClick={() => setActiveView("grid")}
                      className={getButtonClasses("grid")}
                    >
                      <RiGridFill size={20} />
                    </button>
                  </Whisper> */}

                  {/* <Whisper
                    placement="top"
                    trigger="hover"
                    speaker={<Tooltip>Filter Options</Tooltip>}
                  >
                    <button
                      onClick={() => {
                        setActiveView("filter");
                      }}
                      type="button"
                      className={getButtonClasses("filter")}
                    >
                      <ClinicFilterPopover />
                    </button>
                  </Whisper> */}
                </div>
              </div>
            </div>
          </div>
          {/* <div className="col-12 d-flex align-items-center mb-4 justify-content-end">
            <span>Choose Date<DatePicker style={{marginLeft:"1rem"}} />  </span>
        </div> */}
        </div>

        {activeView === "list" && (
          <div className="row" style={{ height: "100%", width: "100%" }}>
            <div className="col-12">
              <PrescriptionTable
                 getPrescription={getPrescription}
            isFetching={isFetching}
            isLoading={isLoading}
            isSuccess={isSuccess}
            gridRef={gridRef}
            selectedFilters={selectedFilters}
                hasData={hasData}
            setHasData={setHasData}
              />
            </div>
          </div>
        )}

        <Offcanvas
          show={show}
          onHide={handleClose}
          placement={"end"}
          style={{
            width: "22rem",
            margin: ".5rem .5rem",
            borderRadius: "0.5rem 0rem 0px .5rem",
          }}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title
              className="text-black"
              style={{ fontSize: "18px" }}
            >
              Filters
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body style={{ padding: "none" }}>
            <div className="">
              <PanelGroup accordion className="no-border">
                <Panel header="Check-In Date ">
                  <div className="d-flex align-items-center gap-2">
                    <input type="date" className="form-control" />
                  </div>
                </Panel>
              </PanelGroup>

              <PanelGroup accordion className="no-border">
                <Panel header="Status">
                  <div className="d-flex align-items-center gap-2">
                    <input type="checkbox" />
                    <span>All</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Pending</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>On Recovery </span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Recovered</span>
                  </div>
                </Panel>
              </PanelGroup>

              <PanelGroup accordion className="no-border">
                <Panel header="Diagnosis Filter">
                  <div className="d-flex align-items-center gap-2">
                    <input type="checkbox" />
                    <span>All</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Allergies & Asthma</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Dental Care </span>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <input type="checkbox" />
                    <span>Diabetes</span>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <input type="checkbox" />
                    <span>Hearing Loss</span>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <input type="checkbox" />
                    <span>Sleep Problem</span>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <input type="checkbox" />
                    <span>Other Diagnoses</span>
                  </div>
                </Panel>
              </PanelGroup>

              <PanelGroup accordion className="no-border">
                <Panel header="Check-In Type">
                  <div className="position-relative div-okij8ijj mb-3">
                    <input
                      type="text"
                      className="form-control div-sdwfegere"
                      placeholder="Search"
                      style={{ padding: ".3rem .2rem", borderRadius: ".3rem" }}
                    />
                    <div
                      className="position-absolute"
                      style={{ top: "5px", right: ".2rem" }}
                    >
                      <button style={{ background: "none", border: "none" }}>
                        <i class="fa-solid fa-magnifying-glass"></i>
                      </button>
                    </div>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <input type="checkbox" />
                    <span>All</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>In-person</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Virtual</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Emergency</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Walk-in</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Home Visit</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Telehealth</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Consultation</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Second Opinion</span>
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-3">
                    <input type="checkbox" />
                    <span>Follow-up Visit</span>
                  </div>
                </Panel>
              </PanelGroup>

              <PanelGroup accordion className="no-border">
                <Panel header="Patient Name">
                  <div className="position-relative div-okij8ijj mb-3">
                    <input
                      type="text"
                      className="form-control div-sdwfegere"
                      placeholder="Search"
                      style={{ padding: ".3rem .2rem", borderRadius: ".3rem" }}
                    />
                    <div
                      className="position-absolute"
                      style={{ top: "5px", right: ".2rem" }}
                    >
                      <button style={{ background: "none", border: "none" }}>
                        <i class="fa-solid fa-magnifying-glass"></i>
                      </button>
                    </div>
                  </div>
                </Panel>
              </PanelGroup>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </main>
    </>
  );
}

export default Prescription;
